import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';

interface Props {
  links: string[];
  onCopy: (url: string) => void;
}

const RecentLinks: React.FC<Props> = ({ links, onCopy }) => (
  <Card>
    <CardHeader avatar={<HistoryOutlined color='action' />} title='Recent links' subheader='Kept in this browser only' />
    <CardContent sx={{ pt: 0 }}>
      {links.length === 0 ? (
        <Typography color='text.secondary' variant='body2'>
          Links you copy or open show up here.
        </Typography>
      ) : (
        <List dense disablePadding>
          {links.map((url) => (
            <ListItem
              key={url}
              divider
              disableGutters
              secondaryAction={
                <IconButton edge='end' aria-label='Copy recent link' onClick={() => onCopy(url)}>
                  <ContentCopyOutlined fontSize='small' />
                </IconButton>
              }
            >
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ fontFamily: 'monospace', wordBreak: 'break-all', pr: 5 }}
              >
                {url}
              </Typography>
            </ListItem>
          ))}
        </List>
      )}
    </CardContent>
  </Card>
);

export default RecentLinks;
